import gql from "graphql-tag";

const CONSTITUENTS_QUERY = gql`
query Event($eventId: String!){
    constituents(eventId: $eventId){
        Name
        FirstName
        LastName
        Amount
        Date
        Individual
        BatchNumber
        Organization
        MajorSponsor
        BaseCurrencyId
        LookupId
        RevenueId
        EventLookupId
        Household

    }
}`

export default CONSTITUENTS_QUERY;